module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/1_4e66cc515f7fde1cecf90ae054f3986b.png";